export interface PlaceOfServiceInterface {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export class PlaceOfService implements PlaceOfServiceInterface {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: PlaceOfServiceInterface) {
    this.id = data.id;
    this.name = data.name;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
